import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { combineLatest, map, Observable, Subject, Subscription } from 'rxjs';
import { ConstantMessages } from 'src/app/common/ConstantMessages';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { SeoService } from 'src/app/seo.service';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { DomSanitizer, makeStateKey, TransferState } from '@angular/platform-browser';
import { isPlatformServer } from '@angular/common';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from 'src/app/shared/components/Login/Login.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HowItWorksEditComponent } from '../how-it-works-edit/how-it-works-edit.component';
@Component({
  selector: 'app-edit-video-for-me',
  templateUrl: './edit-video-for-me.component.html',
  styleUrls: ['./edit-video-for-me.component.scss']
})
export class EditVideoForMeComponent {
  subscription = new Subscription();
  public pTemplateId: any = '';
  public pUserVideoId: any = '';
  public marketingAgent: string;
  userDetails: any = {};
  public tempUserId = 0;
  public constants: Constants;
  public constantMessages: ConstantMessages;
  public messageType: any;
  videoDesc = "";
  isDataLoaded: boolean = false;
  assetURL = environment.assetURL;
  TemplateMetaData: any = {}
  editVideoForMeForm: FormGroup;
  submitted = false;
  public safeVideoValue: any;
  invitationType;
  isGenericTemplate: boolean = false;
  constructor(
    private ngbModel: NgbModal,
    private _httpService: HTTPService,
    private _router: Router,
    private messageService: MessageService,
    public toastr: ToastrService,
    private modalService: NgbModal, private _route: ActivatedRoute,
    public sharedService: SharedService,
    private seoService: SeoService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) public platformId,
    private dialog: MatDialog, private _formBuilder: FormBuilder, public sanitizer: DomSanitizer
  ) {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (this.userDetails != null && this.userDetails != undefined)
      this.tempUserId = this.userDetails.UserId;
    this.constants = new Constants();
    this.constantMessages = new ConstantMessages();
    this.messageType = this.constants.messageType;
  }
  ngOnInit() {
    this.editVideoForMeForm = this._formBuilder.group({
      Name: ['', Validators.required],
      Email: ['', [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$")
      ]],
      PhoneNo: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]],
    });
    this.subscription.add(
      combineLatest([this._route.params, this._route.queryParams])
        .pipe(map(results => ({ params: results[0], query: results[1] })))
        .subscribe(results => {
          const queryData = this.sharedService.decryptAndParseQueryString(results.params.data);
          if (queryData != undefined) {
            this.pTemplateId = queryData.templateId;
            if (this.pTemplateId == 1000)
              this.isGenericTemplate = true;
            this.pUserVideoId = queryData.userVideoId;
            this.marketingAgent = queryData.marketingAgent;
            this.invitationType = queryData.invitationType;
          }
          this.videoDesc = results.params.videoDesc;
          this.sharedService.isShowLoader.next(true);
          if (!isNaN(this.pTemplateId) && this.pTemplateId > 0) {
            this.GetTemplateDataList();
          }
        })
    );
    this.mapUserDetailsIfLoggedIn();
  }
  get f() { return this.editVideoForMeForm.controls; }
  public GetTemplateDataList() {
    const Personalise_Key = makeStateKey("Personalise_Key");
    if (this.transferState.hasKey(Personalise_Key)) {
      const data = this.transferState.get(Personalise_Key, null);
      if (!isPlatformServer(this.platformId)) {
        this.transferState.remove(Personalise_Key);
      }
      this.ProcessGetTemplate(data);
    }
    else {
      this.subscription.add(
        this._httpService.ajaxPost('Personalize/GetTemplateData', { pTemplateId: this.pTemplateId }).subscribe(
          data => {
            if (isPlatformServer(this.platformId)) {
              this.transferState.set(Personalise_Key, data);
            }
            this.ProcessGetTemplate(data);
          },
          (error: any) => {
            this.sharedService.isShowLoader.next(false);
          }));
    }
  }
  private ProcessGetTemplate(data: any) {
    if (data["Message"].MessageTypeValue == this.messageType.Success) {
      this.sharedService.isPageDataLoaded = true;
      this.isDataLoaded = true;
      var templateDataList = data["TemplateData"];
      this.seoService.generateTags({
        title: `Personalise ${templateDataList.VideoName} | video invitation | Online Video Invitation Maker | Create Online Video Invitations - Wedding, Engagement, Birthday, Anniversary & more. - 247Invites.com`,
        description: `Personalise ${templateDataList.VideoName} video invitation | Create Customized Video Invitations Online for Wedding, Engagement, Birthday, Reception, Anniversary, House warming, Naamkaran, Cradle, Baptism, Christening, Half Sari, Valentines Day, Christmas, Diwali, New Year, etc. Download and share using WhatsApp, Facebook, and more.`,
        image: `${this.assetURL}/${templateDataList.ThumbnailImage}`,
        slug: this._router.url
      });
      if (this.userDetails != null)
        this.TemplateMetaData.UserId = this.userDetails.UserId;
      this.TemplateMetaData.UserVideoId = templateDataList.UserVideoId;
      this.TemplateMetaData.TemplateId = templateDataList.TemplateId;
      this.TemplateMetaData.TemplateName = templateDataList.TemplateName;
      this.TemplateMetaData.VideoDuration = templateDataList.VideoDuration;
      this.TemplateMetaData.AudioPath = templateDataList.AudioPath;
      this.TemplateMetaData.VideoLink = templateDataList.VideoLink;
      var SlideData = [];
      templateDataList.SlideData?.forEach(element => {
        var SlideDataObj = { SlideId: 0, SlideName: '', SlideImageLink: '', SlideSequence: '', SlidePreviewFormate: '', IsIncluded: true, FieldData: [] };
        SlideDataObj.SlideId = element.SlideId;
        SlideDataObj.SlideName = element.SlideName;
        SlideDataObj.SlideImageLink = this.assetURL + "/" + element.SlideImageLink;
        SlideDataObj.SlideSequence = element.SlideSequence;
        SlideDataObj.SlidePreviewFormate = element.SlidePreviewFormate;
        SlideDataObj.FieldData = [];
        if (element.FieldData != null) {
          element.FieldData.forEach(elementField => {
            var FieldDataObj = { FieldId: 0, FieldType: '', FieldName: '', FieldValue: '', FieldToolTip: '', IsOptional: false, FileEvent: '', FileCroppedValue: '', IsEdited: false, FieldLength: '', AspectRatio: '', CasingTypeId: '', FieldShapeId: '' };
            FieldDataObj.FieldId = elementField.FieldId;
            FieldDataObj.FieldType = elementField.FieldType;
            FieldDataObj.FieldName = elementField.FieldName;
            FieldDataObj.FieldValue = elementField.FieldValue;
            FieldDataObj.IsOptional = elementField.IsOptional;
            FieldDataObj.FieldLength = elementField.FieldLength;
            FieldDataObj.AspectRatio = elementField.AspectRatio;
            FieldDataObj.CasingTypeId = elementField.CasingTypeId;
            FieldDataObj.FieldShapeId = elementField.FieldShapeId;
            FieldDataObj.FieldToolTip = elementField.FieldToolTip;
            SlideDataObj.FieldData.push(FieldDataObj);
          });
        }
        let slideIncludeFilter = SlideDataObj.FieldData.filter(x => x.FieldName == "SlideInclude");
        if (slideIncludeFilter.length == 0) {
          SlideDataObj.IsIncluded = true;
        }
        else {
          let slideInclude = slideIncludeFilter[0].FieldValue;
          if (slideInclude != undefined && slideInclude != "") {
            SlideDataObj.IsIncluded = slideInclude == "false" ? false : true;
          }
        }
        SlideData.push(SlideDataObj);

      });
      this.TemplateMetaData.SlideData = SlideData;
      this.sharedService.isShowLoader.next(false);
    } else {
      this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
    }
    this.loadVideoURL();
    this.sharedService.isShowLoader.next(false);
  }
  public SaveTemplateData() {
    this.submitted = true;
    if (this.editVideoForMeForm.valid) {
      this.sharedService.isShowLoader.next(true);
      this.userDetails = JSON.parse(localStorage.getItem("userDetails"));

      this.TemplateMetaData.VideoStatus = this.constants.videoStatus.Draft;
      if (this.userDetails != null) {
        if (this.TemplateMetaData.userId == null || this.TemplateMetaData.userId == undefined)
          this.TemplateMetaData.userId = this.userDetails.UserId;
        this.TemplateMetaData.MarketingAgent = this.marketingAgent;
        this.TemplateMetaData.InvitationType = this.invitationType;
        let objUserInfo = Object.assign({});
        objUserInfo.UserId = this.TemplateMetaData.userId;
        objUserInfo.PhoneNo = this.editVideoForMeForm.controls["PhoneNo"].value;
        this._httpService.ajaxPost("User", objUserInfo).subscribe((userData) => {
          if (userData) {
            this.userDetails.Phone = this.editVideoForMeForm.controls["PhoneNo"].value;
            localStorage.setItem("userDetails", JSON.stringify(this.userDetails));
            this._httpService.ajaxPost("Personalize/SaveTemplateData", this.TemplateMetaData).subscribe((data) => {
              if (data["Message"].MessageTypeValue == this.constants.messageType.Success) {
                var templateDataList = data["TemplateData"];
                this.pUserVideoId = templateDataList.UserVideoId;
                let encryptedqueryparams: { userVideoId: any; isEditForMe: boolean };
                encryptedqueryparams = {
                  userVideoId: this.pUserVideoId,
                  isEditForMe: true
                };
                this._router.navigate([`/userpayment/${this.videoDesc}/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
                this.sharedService.isShowLoader.next(false);
              }
              else {
                this.sharedService.isShowLoader.next(false);
              }
            }, (error: any) => {
              this.toastr.error(JSON.parse(error).Message["Text"]);
              this.sharedService.isShowLoader.next(false);
            });
          }
          else {
            this.toastr.error("Error while processing your request");
          }
        }, () => {
          this.toastr.error("Error while processing your request");
          this.sharedService.isShowLoader.next(false);
        });
      }
      else {
        const modelRef = this.ngbModel.open(LoginComponent, {
          size: 'lg',
          windowClass: 'login-dialog'
        });
        modelRef.componentInstance.name = this.editVideoForMeForm.controls["Name"].value;
        modelRef.componentInstance.phone = this.editVideoForMeForm.controls["PhoneNo"].value;
        modelRef.componentInstance.email = this.editVideoForMeForm.controls["Email"].value;
        modelRef.result.then((data) => {
          this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
          if (this.userDetails != null && this.userDetails != '')
            this.SaveTemplateData();
        });
        //this.isShowLoader = false;
        this.sharedService.isShowLoader.next(false);
      }
    }
  }
  mapUserDetailsIfLoggedIn() {
    this.editVideoForMeForm.controls["Name"].setValue(this.userDetails?.Name);
    this.editVideoForMeForm.controls["Email"].setValue(this.userDetails?.Email);
    this.editVideoForMeForm.controls["PhoneNo"].setValue(this.userDetails?.Phone);
  }
  loadVideoURL() {
    if (this.TemplateMetaData != null && this.TemplateMetaData != undefined) {
      this.safeVideoValue = this.sanitizer.bypassSecurityTrustResourceUrl(this.TemplateMetaData?.VideoLink + "?wmode=transparent&amp;rel=0");
    }
    else
      this.safeVideoValue = '';
    if (this.safeVideoValue == '') {
      this.safeVideoValue = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/flg1n5UX-n8" + "?wmode=transparent&amp;rel=0");
    }
  }
  editForMe() {
    const modelRef = this.modalService.open(HowItWorksEditComponent, {
      size: 'lg'
    });
  }
}

